export const NAME = 'producedProduction-documents';

export const formDataFieldsMap = {
	channel: 'Distribuční kanál',
	region: 'Region',
	agency: 'Oblast',
	manager: 'Manažer',
	seller: 'Obchodník',
	ppz: 'Podobchodník',
	policyNumber: 'Číslo PS',
	documentType: 'Typ dokumentu',
	scan: 'Sken',
	reportDateFrom: 'Datum vykázání od',
	reportDateTo: 'Datum vykázání do',
	withoutPpz: 'Včetně záznamů podřízených',
};
